import {useEffect, useState} from "react";
import {db} from "../db";

import cardAdd from '../images/icons/image-card-icons/card-icon-add-to-collection.svg';
import cardInCollection from '../images/icons/image-card-icons/card-icon-add-to-collection-active.svg';
import cardRemove from '../images/icons/image-card-icons/card-icon-remove.svg';
import cardCopy from '../images/icons/image-card-icons/card-icon-copy-image.svg';
import cardCopyDescription from '../images/icons/image-card-icons/card-icon-copy-description.svg';
import cardSave from '../images/icons/image-card-icons/card-icon-save-image.svg';
import cardSaveDescription from '../images/icons/image-card-icons/card-icon-save-description.svg';
import cardPopulatePrompt from '../images/icons/image-card-icons/card-icon-populate-prompt.svg';
import cardZoom from '../images/icons/image-card-icons/card-icon-zoom-in.svg';
import cardShare from '../images/icons/image-card-icons/card-icon-share-to-community.svg';
import cardTag from '../images/icons/image-card-icons/card-icon-tag.svg';
import cardPublic from '../images/icons/image-card-icons/card-icon-public.svg';
import cardPrivate from '../images/icons/image-card-icons/card-icon-private.svg';
import cardEye from '../images/icons/image-card-icons/card-icon-eye.svg';
import cardImageDescribe from '../images/icons/image-card-icons/card-icon-describe-image.svg';
import uploadIconWhite from "../images/icons/input-bar-icons/icon-input-bar-upload-white.svg";
import cardEdit from '../images/icons/image-card-icons/card-icon-edit.svg'
import CloseIcon from "../images/icons/white-close.svg";
import Image from "image-js";
import CollectSound from "../sounds/collect.flac";
import { useDriverContext, useDriverContextDispatch } from "../context/DriverContext";
import { useCollectionContext, useCollectionContextDispatch } from "../context/CollectionContext";
import { useAccountContext } from "../context/AccountContext";
import 'react-responsive-modal/styles.css';
import { Modal } from 'react-responsive-modal';
import Select, {InputAction} from 'react-select';
import makeAnimated from 'react-select/animated'
import { isUndefined } from "cropperjs";
import Swal from "sweetalert2";
import ToggleInput from "./inputs/ToggleInput";
import {
    changeImageVisibility,
    deleteCollectionImage,
    getCollectionImage, getImageDescription, getImageMetadata, getPromptFileData,
    updateAccount,
    updateImageTags,
    shareImage, shareToSocialMedia,
    getProgress,
    getGenerateOutput,
    setReceived
} from "../api-helper";
import { useNavigate } from "react-router-dom";

import { useGenerateDispatch, useGenerateStatus } from "../context/GenerateContext";
//import { useGenerateStatus } from "../context/GenerateContext";
import { usePromptContext } from '../context/PromptContext';
import { copyDescriptionToClipboard, downloadDescriptionAsPromptFile, populatePromptField } from './ImageDescriptionUtils';
import { memo } from "react";

import {
    EmailIcon,
    EmailShareButton, FacebookIcon,
    FacebookShareButton, LinkedinIcon,
    LinkedinShareButton,
    TwitterIcon,
    TwitterShareButton, WhatsappIcon,
    WhatsappShareButton, XIcon
} from "react-share";
import { usePromptusAPIState } from "../context/PromptusAPIContext";
import FullImageViewer from "./FullImageViewer";

const animatedComponents = makeAnimated()

export function downloadString(text, fileType, fileName) {
    const blob = new Blob([text], { type: fileType });

    const a = document.createElement('a');
    a.download = fileName;
    a.href = URL.createObjectURL(blob);
    a.dataset.downloadurl = [fileType, a.download, a.href].join(':');
    a.style.display = "none";
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
    setTimeout(function() { URL.revokeObjectURL(a.href); }, 1500);
}

const CollectionImage = memo((props) => {
    const [promptInfo, setPromptInfo] = useState({});
    const [showSaveDialog, setShowSaveDialog] = useState(false);
    //const [showShareDialog, setShowShareDialog] = useState(false);
    const [privateImage, setPrivateImage] = useState(true);
    const [dimensions, setDimensions] = useState('0 x 0');
    const [visibility, setVisibility] = useState("");
    const [downloadName, setDownloadName] = useState(`Promptus_${props.uid}`)
    const [tags, setTags] = useState([]);
    const driverContextDispatch = useDriverContextDispatch();
    const collectionContextDispatch = useCollectionContextDispatch();
    const collectionContext = useCollectionContext();
    const accountContext = useAccountContext();
    const [open, setOpen] = useState(false);
    const [openDescribeImage, setOpenDescribeImage] = useState(false);
    const [openShare, setShare] = useState(false);
    const [tag, setTag] = useState("");
    const [multiTag, setMultiTag] = useState("");
    const [options, setOptions] = useState([]); 
    const [inputTag, setInputTag] = useState("");
    const [selectedOptions, setSelectedOptions] = useState([]);
    const [clearTags, setClearTags] = useState(false);
    const [tagLoading, setTagLoading] = useState(false);
    const [failedImage, setFailedImage] = useState(false);
    const [imageRegenerating, setImageRegenerating] = useState(false);
    const [imageIDRegenerating, setImageIDRegenerating] = useState(0);
    const [workloadRegenerating, setWorkloadRegenerating] = useState(false);
    const [workloadUidRegenerating, setWorkloadUidRegenerating] = useState("");
    const [regenLogic, setRegenLogic] = useState(false);
    const [imageDescription, setImageDescription] = useState("");
    const navigate = useNavigate();
    const generateStatus = useGenerateStatus();
    const generateStatusDispatch = useGenerateDispatch();
    const { updatePrompt } = usePromptContext();
    const [clipboardMessage, setClipboardMessage] = useState('');
    const [shareUrl, setShareUrl] = useState('');
    const apiState = usePromptusAPIState();
    const [imageDescriptionLoading, setImageDescriptionLoading] = useState(false);
    const [localInCollection, setLocalInCollection] = useState(props.inCollection);
    const [showShareImageDialog, setshowShareImageDialog] = useState(false);
    const [zoomedImage, setZoomedImage] = useState(null)

    useEffect(() => {
        setPromptInfo({prompt: props.prompt})
        

        if (props.public) {
            setVisibility("Public");
            setPrivateImage(false);
        } else {
            setVisibility("Private")
            setPrivateImage(true);
        }
        setTag(props.tag);

        if (props.image == '' || generateStatus.failedImage) {
            setFailedImage(true);
        } else {
            setFailedImage(false);
        }

        if (generateStatus.failedImageID !== null) {
            setImageIDRegenerating(generateStatus.failedImageID);
        }
    }, [props.uid]);

    /**
     * Tries to grab the collection image with the given uid
     * @returns {Promise<*>}
     */
    const getSpecificImage = async (uid) => {
        return await db.collection
            .where('uid')
            .equals(uid)
            .first();
    }

    const addToCollection = async () => {
        if (accountContext.loggedIn === false) {
            Swal.fire({
                title: "Not Logged In",
                text: "You need to be logged in to add images to your collection. Please login to your account to proceed.",
                icon: "error",
                confirmButtonText: "Ok",
                confirmButtonColor: "#FFB02E",
            }).then((result) => {
                if (result.isConfirmed) {
                    navigate('/profile')
                }
            })
            return;
        }

        // Set the lock
        await db.settings.put({ key: 'toggleLock', value: true });

        // Pre-loading Sound File and setting check
        const collectAudio = new Audio(CollectSound);
        const soundSettingCheck = await db.settings.where('key').equals('play_sounds').first()

        try {
            // Check if image already exists in collection
            const imageCount = await db.collectedImages.where('image').equals(props.image).count();

            if (imageCount === 0) {
                // Get the current count for new image ID
                let iCount;
                await db.collectedImages.count((collectedCount) => {
                    iCount = collectedCount + 1;
                });

                // Add to collectedImages DB
                await db.images.update(props.id, { inCollection: true });

                await db.collectedImages.put({
                    uid: props.uid,
                    imageID: iCount,
                    image: props.image,
                    seed: props.seed,
                    model: props.model,
                    hash: props.hash,
                    online: props.online,
                    tag: props.tag,
                    prompt: promptInfo.prompt,
                    public: false
                });

                // Update remote collection
                const image = await getSpecificImage(props.uid);
                if (image) {
                    let imageArr = [{
                        uid: props.uid,
                        image: props.image,
                        seed: props.seed,
                        model: props.model,
                        hash: props.hash,
                        online: props.online,
                        tag: props.tag,
                        prompt: promptInfo.prompt,
                    }];
                    let colArr = [image];

                    await updateAccount(
                        JSON.stringify(imageArr),
                        accountContext.accountDetails.accountNo,
                        null,
                        JSON.stringify(colArr)
                    );
                }

                // Play sound if enabled
                if (soundSettingCheck.value) {
                    collectAudio.loop = false;
                    collectAudio.volume = 0.8;
                    collectAudio.play();
                }
            }

            // Add a delay to ensure API processing
            await new Promise(resolve => setTimeout(resolve, 2000));
        } finally {
            // Release the lock
            await db.settings.put({ key: 'toggleLock', value: false });
        }
    };


    const toggleCollection = async () => {
        if (accountContext.loggedIn === false) {
            Swal.fire({
                title: "Not Logged In",
                text: "You need to be logged in to add images to your collection. Please login to your account to proceed.",
                icon: "error",
                confirmButtonText: "Ok",
                confirmButtonColor: "#FFB02E",
            }).then((result) => {
                if (result.isConfirmed) {
                    navigate('/profile')
                }
            })
            return;          
        }

        // Set the toggle lock
        await db.settings.put({ key: 'toggleLock', value: true });

        // Pre-loading Sound File and setting check
        const collectAudio = new Audio(CollectSound);
        const soundSettingCheck = await db.settings.where('key').equals('play_sounds').first()
        try{
        const inCollection = !props.inCollection;

        let inPlayground = false;
        let propsId = props.id;
        await db.images.where('image').equals(props.image).toArray(async(images) => {
            if (images.length > 0) {
                propsId = images[0].id;
                inPlayground = true;
            }
        });

        await db.images
            .update(propsId, {inCollection})
            .then(async () => {
                await db.collectedImages.where('image').equals(props.image).count(async(imageCount) => {
                    if (imageCount > 0) {
                        // removing the image from the collection
                        if (!inCollection) {
                            if (!inPlayground) {
                                await db.collectedImages.where('image').equals(props.image).toArray(async(collectedImage) => {
                                    if (collectedImage.length > 0) {
                                        console.log("Adding image to playground");
                                        // THIS SHOULD BE IN THE SAME FORMAT AS getPromptFileData
                                        await getImageMetadata(accountContext.accountDetails.accountNo, collectedImage[0].hash)
                                            .then((prompt) => {
                                                db.collection.put({
                                                    uid: collectedImage[0].uid,
                                                    prompt : prompt.prompt,
                                                    queue:  'RC' + (Math.random() + 1).toString(36).substring(2).toUpperCase(),// We don't have this value as it wasn't created in this playground - create a dummy value
                                                    timestamp: Date.now(),
                                                });
                                            })
                                            .finally(() => {
                                                console.log("Added image history to local db");
                                            })

                                        await db.images.put({
                                           image : collectedImage[0].image,
                                           seed: collectedImage[0].seed,
                                           uid: collectedImage[0].uid,
                                           model: collectedImage[0].model,
                                           inCollection: false,
                                           hash: collectedImage[0].hash,
                                           online: collectedImage[0].online,
                                           tag: collectedImage[0].tag
                                       });
                                    }
                                });
                            }


                            db.collectedImages.where('image').equals(props.image).delete();
                            console.log("Removing image from collection DB");
                            deleteCollectionImage(accountContext.accountDetails.accountNo, props.hash)
                            props.refreshImages()
                        }
                    } else {
                        // adding the image to the collection
                        let iCount
                        await db.collectedImages.count((collectedCount) => {
                            iCount = collectedCount + 1;
                        })
                        console.log("Adding image to collection DB: ", iCount);
                        console.log(props);

                        db.collectedImages.put({uid: props.uid, imageID: iCount, image: props.image, seed: props.seed, model: props.model, hash: props.hash, online: props.online, tag: props.tag, prompt:promptInfo.prompt, public: false})

                        getSpecificImage(props.uid).then((image) => {
                                if (image) {
                                    let imageArr = [{
                                        uid: props.uid,
                                        image: props.image,
                                        seed: props.seed,
                                        model: props.model,
                                        hash: props.hash,
                                        online: props.online,
                                        tag: props.tag,
                                        prompt:promptInfo.prompt,
                                    }]
                                    let colArr = [image]

                                    console.log("Going through the update API call: ", imageArr, " | ", colArr);
                                    updateAccount(JSON.stringify(imageArr), accountContext.accountDetails.accountNo, null, JSON.stringify(colArr))
                                }
                            });
                    }
                });
                // props.refreshImages();
            }).then(async () => {
                setLocalInCollection(!localInCollection);
                if (soundSettingCheck.value && inCollection) {
                    // const collectAudio = new Audio(CollectSound);
                    collectAudio.loop = false;
                    collectAudio.volume = 0.8;
                    collectAudio.play();
                }
            });
        // Add a delay to ensure API processing
        await new Promise(resolve => setTimeout(resolve, 2000));
    } finally {
        // Release the toggle lock
        await db.settings.put({ key: 'toggleLock', value: false });
    }
}

    const deleteImage = async () => {
        let imageNotFound = false;
        if (props.isMyCollection) {
            db.collectedImages
                .where("id")
                .equals(props.id)
                .delete()
                .then(async () => {
                    console.log("check if image is in generated images and remove the flag");
                    // check if image is in generated images and remove the flag
                    await db.images.where('image').equals(props.image).toArray(async(images) => {
                        if (images.length > 0) {
                            // removing the image from the collection
                            db.images.update(images[0].id, {inCollection: false})
                            console.log("Removing image from collection");
                            Swal.fire({
                                color: "#190A4E",
                                title: "Confirm Delete",
                                text: `Are you sure you want to delete this image from your ${props.isMyCollection ? "Collection" : "Playground"}?`,
                                icon: "info",
                                confirmButtonText: 'Yes',
                                confirmButtonColor: "#FFB02E",
                                showDenyButton: true,
                                denyButtonText: "No",
                                denyButtonColor: "#190A4E",
                            }).then((result) => {
                                if (result.isConfirmed) {
                                    deleteCollectionImage(accountContext.accountDetails.accountNo, images[0].hash)
                                    .then((data) => props.refreshImages())
                                }
                            })
                        } else {
                            imageNotFound = true;
                        }
                    });
                    if (imageNotFound) {
                        Swal.fire({
                            color: "#190A4E",
                            title: "Confirm Delete",
                            text: `Are you sure you want to delete this image from your ${props.isMyCollection ? "Collection" : "Playground"}?`,
                            icon: "info",
                            confirmButtonText: 'Yes',
                            confirmButtonColor: "#FFB02E",
                            showDenyButton: true,
                            denyButtonText: "No",
                            denyButtonColor: "#190A4E",
                        }).then((result) => {
                            if (result.isConfirmed) {
                                deleteCollectionImage(accountContext.accountDetails.accountNo, props.hash)
                                .then((data) => props.refreshImages())
                            }
                        })
                    }
                });
            return;
        }
        Swal.fire({
            color: "#190A4E",
            title: "Confirm Delete",
            text: `Are you sure you want to delete this image from your ${props.isMyCollection ? "Collection" : "Playground"}?`,
            icon: "info",
            confirmButtonText: 'Yes',
            confirmButtonColor: "#FFB02E",
            showDenyButton: true,
            denyButtonText: "No",
            denyButtonColor: "#190A4E",
        }).then((result) => {
            if (result.isConfirmed) {
                db.images
                .where("id")
                .equals(props.id)
                .delete()
                .then(props.refreshImages);
            }
        })

    }
    const base64toBlob = (b64Data, contentType='', sliceSize=512) => {
        const byteCharacters = atob(b64Data);
        const byteArrays = [];

        for (let offset = 0; offset < byteCharacters.length; offset += sliceSize) {
            const slice = byteCharacters.slice(offset, offset + sliceSize);

            const byteNumbers = new Array(slice.length);
            for (let i = 0; i < slice.length; i++) {
                byteNumbers[i] = slice.charCodeAt(i);
            }

            const byteArray = new Uint8Array(byteNumbers);
            byteArrays.push(byteArray);
        }

        const blob = new Blob(byteArrays, {type: contentType});
        return blob;
    }

    // const downloadImage = (contentType, ext) => {
    //     // https://stackoverflow.com/questions/16245767/creating-a-blob-from-a-base64-string-in-javascript
        
    //     const blobFile = base64toBlob(props.image, contentType);
    //     const blobUrl = URL.createObjectURL(blobFile);
    //     const link = document.createElement("a");
    //     link.href = blobUrl;
    //     link.download = `${downloadName}.${ext}`;
    //     document.body.appendChild(link);
    //     link.dispatchEvent(new MouseEvent('click', {
    //         bubbles: true,
    //         cancelable: true,
    //         view: window
    //     }));
    //     document.body.removeChild(link);
    // };

    const downloadImage = (contentType, ext) => {
        console.log("Downloading Image");
        
        try {
            // Extract base64 data
            // const base64Data = props.image.split(',')[1];
            // const imageBuffer = atob(base64Data); // Decode base64 to binary
            const img = new Image();
    
            console.log("Downloading Image 2");
    
            img.onerror = (error) => {
                console.error('Error loading image:', error);
            };

            img.onload = () => {
                // Create a canvas and draw the image
                console.log("Downloading Image 3");
                const canvas = document.createElement('canvas');
                canvas.width = img.width;
                canvas.height = img.height;
                const ctx = canvas.getContext('2d');
                ctx.drawImage(img, 0, 0);
    
                // Convert the canvas to a PNG
                canvas.toBlob((blob) => {
                    const blobUrl = URL.createObjectURL(blob);
    
                    // Trigger the download
                    const link = document.createElement('a');
                    link.href = blobUrl;
                    link.download = `${downloadName}.png`;
                    document.body.appendChild(link);
                    link.click();
                    document.body.removeChild(link);
    
                    // Revoke the Blob URL to free memory
                    URL.revokeObjectURL(blobUrl);
                }, 'image/png');
            };

            
            img.src = `data:image/png;base64,${props.image}`;

        } catch (error) {
            console.error('Error generating PNG:', error);
        }
    };
    
    

    const downloadPrompt = async () => {
        console.log("DOWNLOADING PROMPT")
        const item = await db.collection.where('uid').equals(props.uid).first();

        if (item) {
            downloadString(JSON.stringify(item), 'application/json', `${downloadName}.prompt`);
        } else {
            // THIS SHOULD BE IN THE SAME FORMAT AS getImageMetadata
            getPromptFileData(accountContext.accountDetails.accountNo, props.uid).then((prompt) => {
                console.log(prompt)
                db.collection.put({
                    uid: prompt.uid,
                    prompt : prompt,
                    queue:  'RC' + (Math.random() + 1).toString(36).substring(2).toUpperCase(),// We don't have this value as it wasn't created in this playground - create a dummy value
                    timestamp: Date.now(),
                });
                downloadString(JSON.stringify(prompt), 'application/json', `${downloadName}.prompt`);
            });
        }

    }

    const copyImageToClipboard = () => {
        const blob = base64toBlob(props.image, 'image/png');
        navigator.clipboard.write([
            new ClipboardItem({
                [blob.type]: blob
            })
        ]).then(() => {
            console.log('Copied')
        })
    }

    const handleTagging = () => {
        setOptions([]);

        const combinedTags = [...collectionContext.tags, ...collectionContext.collectionTags];
        const uniqueTags = [...new Set(combinedTags)];

        const sortedTags = uniqueTags.sort((a, b) => a.localeCompare(b));
        setOptions(sortedTags.map(tag => ({ value: tag, label: tag })));
        setOpen(true)
    }

    useEffect(() => {}, [tag])

    const editTagOnImage = () => {
        setTagLoading(true);
        let multiOptions = "";
        let initTag
        let concate

        setTimeout(() => {
            if (isUndefined(props.tag) == false) {
                if (clearTags == false) {
                    initTag = props.tag + ","
                } else {
                    initTag = "";
                }
            } else {
                initTag = "";
            }
            if (selectedOptions !== "" && !selectedOptions.includes("undefined")) {
                selectedOptions.map((arrValue) => {
                    if (!initTag.includes(arrValue.value) || clearTags == true){
                        multiOptions += arrValue.value + ",";
                    }
                })
                initTag += multiOptions;
            }


        }, 1000)

        setTimeout(() => {
            if (inputTag !== "") {
                if (!initTag.includes(inputTag)){
                    concate = initTag + inputTag
                } else {
                    concate = initTag
                }
            } else {
                concate = initTag;
            }   
            if (concate.endsWith(',')) {
                concate = concate.slice(0, -1);
            }
            if (concate.startsWith(',')) {
                concate = concate.substring(1);
            }
            if (concate == '') {
                Swal.fire({
                    color: "#190A4E",
                    title: "Tag Empty",
                    text: "You cannot tag an image with an empty tag. Please add a tag to the image before proceeding.",
                    icon: "info",
                    timer: 2000,
                    timerProgressBar: true,
                    showConfirmButton: false
                })
                setTagLoading(false);
                return;
            }  
            setTag(concate)
            props.dbTable.update(props.id, {tag: concate}).then(async(updated) => {
                if (updated) {
                    if (props.isMyCollection) {
                        // Update the tag in the images table if it exists
                        let generatedImages = [];
                        await db.images.reverse().toArray((images) => {
                            generatedImages = images;
                        });
                        let imageInImagesTable;
                        generatedImages.forEach((image) => {
                            if (image.hash === props.hash) {
                                imageInImagesTable = image;
                            }
                        })
                        if (imageInImagesTable) {
                            db.images.update(imageInImagesTable.id, { tag: concate });
                        } else {
                            console.log("Image not found in the images table");
                        }
                        console.log("Update Image Tags Route: ", props.hash);
                        updateImageTags(accountContext.accountDetails.accountNo, props.hash, concate)

                    } else {
                        let collectionImages = [];
                        await db.collectedImages.reverse().toArray((images) => {
                            collectionImages = images;
                        });
                        let imageInCollectionTable;
                        collectionImages.forEach((image) => {
                            if (image.hash === props.hash) {
                                imageInCollectionTable = image;
                            }
                        })
                        if (imageInCollectionTable) {
                            db.collectedImages.update(imageInCollectionTable.id, { tag: concate });
                        } else {
                            console.log("Image not found in the collection table");
                        }
                    }
                    Swal.fire({
                        title:"Success",
                        text:"Your image was successfully tagged",
                        icon:"success",
                        timer: 1000,
                        showConfirmButton: false
                    }).then(() => {
                        setTagLoading(false);
                        setInputTag("");
                        setClearTags(false);
                        setSelectedOptions([]);
                        props.refreshTags();
                        if (!props.isMyCollection) {
                            props.refreshImages();
                        }
                        // props.refreshImages();
                    })
                    setOpen(false)
                }
            })

        }, 2500)

    }

    const handleClearTag = () => {
        setClearTags(!clearTags);
    }

    const makeImagePublic = () => {
        console.log(accountContext.accountDetails.alias);
        if (accountContext.accountDetails.alias !== "") {
            props.dbTable.update(props.id, {
                uid: props.uid,
                image: props.image,
                seed: props.seed,
                model: props.model,
                hash: props.hash,
                online: props.online,
                tag: props.tag,
                prompt: promptInfo.prompt,
                public: true
            }).then((updated) => {
                if (updated) {
                    setVisibility("Public");
                    console.log("Change Image Visibility Route: ", props.hash);
                    changeImageVisibility(accountContext.accountDetails.accountNo, props.hash, 1);
                    // props.refreshImages();
                }
            });
        } else {
            Swal.fire({
                title: "No Username",
                text: "You need to have an alias/username in order to make your images available to the public. Please login in to the website and set yourself an alias before proceeding.",
                icon: "error",
                confirmButtonText: "Ok",
                confirmButtonColor: "#FFB02E",
            }).then((result) => {
                if (result.isConfirmed) {
                    window.open("https://signup.promptus.ai/sign-in", "_blank");
                }
            });
        }
    };


    const handlePrivatePublic = async() => {
        if (accountContext.accountDetails.alias !== "") {
            setPrivateImage(!privateImage);
            if (!privateImage) {
                await props.dbTable.update(props.id, {uid: props.uid, image: props.image, seed: props.seed, model: props.model, hash: props.hash, online: props.online, tag: props.tag, prompt:promptInfo.prompt, public: false}).then(async(updated) => {
                    if (updated) {
                        setVisibility("Private")
                        console.log("Changing Image Visibility Route: ", props.hash);
                        await changeImageVisibility(accountContext.accountDetails.accountNo, props.hash, 0)
                        .then(() => {
                            console.log("Image Visibility Changed Successfully");
                        })
                        .catch((e) => {
                            console.log("Image Visibility did not change");
                            setVisibility("Public")
                            setPrivateImage(!privateImage);
                        })
                        // props.refreshImages();
                    }
                })
            } else {
                await props.dbTable.update(props.id, {uid: props.uid, image: props.image, seed: props.seed, model: props.model, hash: props.hash, online: props.online, tag: props.tag, prompt:promptInfo.prompt, public: true}).then(async(updated) => {
                    if (updated) {
                        setVisibility("Public")
                        console.log("Changing Image Visibility Route: ", props.hash);
                        await changeImageVisibility(accountContext.accountDetails.accountNo, props.hash, 1)
                        .then(() => {
                            console.log("Image Visibility Changed Successfully");
                        })
                        .catch((e) => {
                            console.log("Image Visibility did not change");
                            setVisibility("Private")
                            setPrivateImage(!privateImage);
                        })
                        // props.refreshImages();
                    }
                })
            }
        } else {
            Swal.fire({
                title: "No Username",
                text: "You need to have an alias/username in order to make your images available to the public. Please login in to the website and set yourself an alias before proceeding.",
                icon: "error",
                confirmButtonText: "Ok",
                confirmButtonColor: "#FFB02E",
            }).then((result) => {
                if (result.isConfirmed) {
                    window.open("https://signup.promptus.ai/sign-in", "_blank")
                }
            })
        }
    }

    const handleDblClick = (e) => {
        if (e.detail == 2) {
            console.log("Double Click");
            props.setZoomedImage({image: props.image, seed: props.seed})
        }
    }

    const handleEnter = (e) => {
        if (e.key === "Enter") {
            editTagOnImage();
        }
    }

    const handleDragStart = (e) => {
        let imageToDrag = 'data:image/png;base64,' + props.image 
        e.dataTransfer.setData('text/plain', window.location.href);
        e.dataTransfer.setData('text/uri-list', imageToDrag);
    }

    useEffect(() => {
        if (props.image !== '') {
            (async () => await Image.load(`data:image/*;base64,${props.image}`).then((image) => {
                setDimensions(`${image.width} x ${image.height}`)
            }))();
        }
    }, []);

    let model = "";
    if (props.model) model = props.model;

    let regenerating = false;
    const regenerateImage = async(workload) => {
        if (regenerating) {
            console.log("The image regeneration process is already happening");
            return
        };
        regenerating = true;

        console.log("Regenerating Image");
        console.log("UID: ", props);
        let noImages = false;
        if (apiState.online == true) {
            await getProgress(props.uid, apiState, generateStatusDispatch).then(async(data) => {
                console.log("Progress Data: ", data);
                if (data && data.output && Array.isArray(data.output) && data.output.length > 0) {
                    const results = await db.images.where('uid').equals(props.uid).and(item => item.image === '').toArray();
                    const deliveredImages = await db.images.where('uid').equals(props.uid).and(item => item.image !== '').toArray();
                    console.log("Results: ", results);                    

                    const filteredData = data.output.filter(item1 =>
                        deliveredImages.every(item2 => item2.hash !== item1.uid)
                      );

                    console.log("Filtered Data: ", filteredData);
                    
                    
                    const missingImagesCount = results.length;
                    const returnedImagesCount = filteredData.length;
                    let index = 0;
                    
                    if (!workload) {
                        if (missingImagesCount > 1) {
                            Swal.fire({
                                title: "Image found in server",
                                text: "Image found in the server that could not make it to you are being retrieved. Please wait ...",
                                icon: "info",
                                timer: 2500,
                                timerProgressBar: true,
                                showConfirmButton: false
                            })
                            const outputUid = filteredData[0].uid;
                            console.log("Output UID from single image: ", outputUid);
                            const hashcheck = await db.images.where('hash').equals(outputUid).first();
                            const image = await getGenerateOutput(props.uid, outputUid);
                            const imageCheck = await db.images.where('image').equals(image.image).first(); 
                            console.log(image);
                            
                            if (!hashcheck && !imageCheck) {
                                await db.images.update(results[0].id, {
                                    image: image.image,
                                    seed: image.seed,
                                    model: image.model ?? '',
                                    hash: outputUid,
                                    prompt: image.prompt,
                                    receivedtimestamp: Date.now()
                                })
                                setReceived(props.uid, outputUid);
                                props.refreshImages();
                            } else {
                                console.log("Image already exists in the local DB, skipping ...");
                            }
                        }
                        
                    } else {
                        Swal.fire({
                            title: "Image(s) found in server",
                            text: "Image(s) found in the server that could not make it to you are being retrieved. Please wait ...",
                            icon: "info",
                            timer: 2500,
                            timerProgressBar: true,
                            showConfirmButton: false
                        })
                        await Promise.all(
                            filteredData.map(async(item) => {
                                if (index > missingImagesCount) {
                                    console.log("More images returned than missing, stopping the loop.");
                                    if (props.image === '') {
                                        noImages = true;
                                    }
                                } else {
                                    const outputUid = item.uid;
                                    console.log("Output UID from workload: ", outputUid);
                                    const hashcheck = await db.images.where('hash').equals(outputUid).first();
                                    const image = await getGenerateOutput(props.uid, outputUid);
                                    const imageCheck = await db.images.where('image').equals(image.image).first();
                                    console.log(image);
                                    
                                    if (!hashcheck && !imageCheck) {
                                        await db.images.update(results[index].id, {
                                            image: image.image,
                                            seed: image.seed,
                                            model: image.model ?? '',
                                            hash: outputUid,
                                            prompt: image.prompt,
                                            receivedtimestamp: Date.now()
                                        })
                                        setReceived(props.uid, outputUid);
                                        props.refreshImages();
                                    } else {
                                        console.log("Image already exists in the local DB, skipping ...");
                                    }
                                }
                                index++;
                            })
                        )
                        // for (const item of filteredData) {
                        // }
                        if (missingImagesCount > returnedImagesCount) {
                            console.log("More missing images than returned images, some images are still missing.");
                            if (props.image === '') {
                                noImages = true;                    
                            }
                        }
                    }
                } else {
                    noImages = true;
                }
            });
        }
        
        if (apiState.online == false || noImages && props.image === '') {            
            console.log("Regenerating image due to no images in server present or offline mode");
            setImageIDRegenerating(props.id);
            const imageDetails = await db.collection.where('uid').equals(props.uid).toArray();
            let prompt = imageDetails[0].prompt;
            if (!workload) {
                console.log("Image Regeneration");
                prompt.prompt.params.count = 1;
                setWorkloadRegenerating(false);
                setWorkloadUidRegenerating("");
                generateStatusDispatch({type: 'failedImageID', failedImageID: props.id});
                generateStatusDispatch({type: 'failedWorkloadUID', failedWorkloadUID: null});
            } else {
                console.log("Workload Regeneration");
                const results = await db.images.where('uid').equals(props.uid).and(item => item.image === '').toArray();
                prompt.prompt.params.count = results.length;
                setWorkloadRegenerating(true);
                setWorkloadUidRegenerating(props.uid);
                generateStatusDispatch({type: 'failedWorkloadUID', failedWorkloadUID: props.uid});
                generateStatusDispatch({type: 'failedImageID', failedImageID: null});
            }
            prompt.prompt.params.image_batch_size = 1;
            console.log("Prompt: ", prompt);
            props.regenerateImage(prompt, true, props.id);
        }
        regenerating = false;
    }

    const viewDetails = async() => {
        console.log("Viewing Details");
        const imageDetails = await db.collection.where('uid').equals(props.uid).toArray();
        if (imageDetails.length > 0) {
            let prompt = imageDetails[0].prompt;
            props.viewFailedImage(prompt.prompt)
        } else {
            props.viewFailedImage(props.hash)
        }
    }

    useEffect(() => {
        if (props.image !== '') {
            setFailedImage(false);
        }
    }, [props.image])

    useEffect(() => {
        if (generateStatus.status === 'loading' && props.id === generateStatus.failedImageID && generateStatus.failedImage) {
            console.log("This image failed to generate and is now regenerating: ", props.id, imageIDRegenerating);
            setImageRegenerating(true);
        } else if (generateStatus.status === 'loading' && props.uid === generateStatus.failedWorkloadUID && generateStatus.failedImage) {
            console.log("This image failed to generate and is now regenerating: ", props.uid, workloadUidRegenerating);
            setImageRegenerating(true);
        }
        if (generateStatus.status === 'loading') {
            setRegenLogic(true);
        }
        if (generateStatus.status === 'ready' || generateStatus.status === 'done' || generateStatus.status === 'error' || generateStatus.status === 'canceling') {
            setImageRegenerating(false);
            setRegenLogic(false);
        }
    }, [generateStatus.status])

    const handleDescribeImage = async() => {
        console.log("Describe the image")

        setOpenDescribeImage(true)
        setImageDescription("Generating ...");
        setImageDescriptionLoading(true);


        let imageDescription = "";
        const item = await db.imageDescriptions.where('hash').equals(props.hash).first();

        if (item) {
            console.log("Pulling description from local db")
            imageDescription = item.description
            setImageDescription(imageDescription);
        } else {
            console.log("Pulling description from api")

            let imageDescription ;
            
            if (props.inCollection) {
                imageDescription = getImageDescription(accountContext.accountDetails.accountNo, props.hash, "")
            } else {
                imageDescription = getImageDescription(accountContext.accountDetails.accountNo, "", props.image)
            }
            
            imageDescription.then((description) => {
                console.log(description)
                if (description.image_description !== undefined) {
                    imageDescription = description.image_description;

                    if (imageDescription.length > 0) {

                        setImageDescription(imageDescription);
                        setImageDescriptionLoading(false);

                        db.imageDescriptions.put({
                            hash: props.hash,
                            description: imageDescription,
                            timestamp: Date.now()
                        });
                    }
                }
            });
        }
    }

    const shareImageAction = async (platform) => {
        console.log("shareImageAction started");

        // Initialize loading popup
        const loadingPopup = Swal.fire({
            title: 'Processing',
            html: 'Adding to collection...',
            allowOutsideClick: false,
            showConfirmButton: false,
            didOpen: () => {
                Swal.showLoading();
            }
        });

        try {
            if (accountContext.loggedIn === false) {
                loadingPopup.close();
                Swal.fire({
                    title: "Not Logged In",
                    text: "You need to be logged in to add images to your collection. Please login to your account to proceed.",
                    icon: "error",
                    confirmButtonText: "Ok",
                    confirmButtonColor: "#FFB02E",
                }).then((result) => {
                    if (result.isConfirmed) {
                        navigate('/profile')
                    }
                });
                return;
            }

            await db.settings.put({ key: 'toggleLock', value: true });

            try {
                const imageCount = await db.collectedImages.where('image').equals(props.image).count();

                if (imageCount === 0) {
                    Swal.update({ html: 'Adding image to collection...' });

                    let iCount;
                    await db.collectedImages.count((collectedCount) => {
                        iCount = collectedCount + 1;
                    });

                    await db.images.update(props.id, { inCollection: true });

                    await db.collectedImages.put({
                        uid: props.uid,
                        imageID: iCount,
                        image: props.image,
                        seed: props.seed,
                        model: props.model,
                        hash: props.hash,
                        online: props.online,
                        tag: props.tag,
                        prompt: promptInfo.prompt,
                        public: false
                    });

                    const image = await getSpecificImage(props.uid);
                    if (image) {
                        Swal.update({ html: 'Updating remote collection...' });

                        let imageArr = [{
                            uid: props.uid,
                            image: props.image,
                            seed: props.seed,
                            model: props.model,
                            hash: props.hash,
                            online: props.online,
                            tag: props.tag,
                            prompt: promptInfo.prompt,
                        }];
                        let colArr = [image];

                        await updateAccount(
                            JSON.stringify(imageArr),
                            accountContext.accountDetails.accountNo,
                            null,
                            JSON.stringify(colArr)
                        );

                        Swal.update({ html: 'Making image public...' });
                        try {
                            await makeImagePublic();
                        } catch (error) {
                            console.error('Error making image public:', error);
                            throw new Error('Failed to make image public');
                        }
                    }

                    const soundSettingCheck = await db.settings.where('key').equals('play_sounds').first();
                    if (soundSettingCheck.value) {
                        const collectAudio = new Audio(CollectSound);
                        collectAudio.loop = false;
                        collectAudio.volume = 0.8;
                        collectAudio.play();
                    }
                }

                await new Promise(resolve => setTimeout(resolve, 2000));

                const shareConfig = {
                    twitter: {
                        width: 550,
                        height: 420,
                        baseUrl: 'https://twitter.com/intent/tweet',
                        title: 'Share on Twitter'
                    },
                    facebook: {
                        width: 626,
                        height: 436,
                        baseUrl: 'https://www.facebook.com/sharer/sharer.php',
                        title: 'Share on Facebook'
                    }
                };

                if (!(platform in shareConfig)) {
                    throw new Error(`Unsupported platform: ${platform}`);
                }

                // Retry logic for getting the filename
                let retries = 0;
                const maxRetries = 3;
                let data;

                while (retries < maxRetries) {
                    Swal.update({
                        html: `Preparing share link... (Attempt ${retries + 1}/${maxRetries})`
                    });

                    console.log(`Attempt ${retries + 1} to get filename...`);

                    const response = await fetch(`https://api.promptus.ai/api/image/${props.uid}/${props.hash}`, {
                        method: 'GET',
                        headers: {
                            'Authorization': 'Bearer ABCV1828883939JJK'
                        }
                    });

                    if (!response.ok) {
                        throw new Error(`HTTP error! status: ${response.status}`);
                    }

                    data = await response.json();
                    console.log("API Response:", data);

                    if (data.fileName) {
                        break;  // We got the filename, exit the loop
                    }

                    if (data.status === "OK" && !data.fileName) {
                        retries++;
                        if (retries < maxRetries) {
                            Swal.update({
                                html: `Waiting for image processing... (${retries}/${maxRetries})`
                            });
                            await new Promise(resolve => setTimeout(resolve, 5000));
                        }
                    } else {
                        throw new Error('Unexpected API response');
                    }
                }

                if (!data.fileName) {
                    throw new Error('Could not get filename after multiple attempts');
                }

                Swal.update({ html: 'Opening share dialog...' });

                const imageFileName = `${data.fileName}.jpg`;
                const shareUrl = `https://${accountContext.accountDetails.alias}.classic.promptus.ai/share?image=${imageFileName}`;

                const shareContent = {
                    url: shareUrl,
                    text: `Check out this AI-generated image on Promptus!`,
                    hashtags: 'AI,Promptus,AIArt',
                    via: 'promptus_ai'
                };

                const config = shareConfig[platform];
                let shareWindowUrl = platform === 'twitter'
                    ? `${config.baseUrl}?text=${encodeURIComponent(shareContent.text)}&url=${encodeURIComponent(shareContent.url)}&hashtags=${encodeURIComponent(shareContent.hashtags)}&via=${shareContent.via}`
                    : `${config.baseUrl}?u=${encodeURIComponent(shareContent.url)}`;

                const windowFeatures = {
                    width: config.width,
                    height: config.height,
                    left: (window.screen.width / 2) - (config.width / 2),
                    top: (window.screen.height / 2) - (config.height / 2)
                };

                const windowFeaturesString = Object.entries(windowFeatures)
                    .map(([key, value]) => `${key}=${value}`)
                    .join(',');

                const shareWindow = window.open(
                    shareWindowUrl,
                    config.title,
                    windowFeaturesString
                );

                if (!shareWindow) {
                    throw new Error('Popup was blocked');
                }

                // Close the loading popup only after share window is opened
                loadingPopup.close();

            } finally {
                await db.settings.put({ key: 'toggleLock', value: false });
            }

        } catch (error) {
            console.error('Error in shareImageAction:', error);
            loadingPopup.close();
            Swal.fire({
                title: "Error",
                text: error.message === 'Popup was blocked'
                    ? "Please allow popups to share this content"
                    : "Sorry, there was an error sharing the image. Please try again.",
                icon: "error",
                confirmButtonText: "Ok",
                confirmButtonColor: "#FFB02E",
            });

            try {
                await db.settings.put({ key: 'toggleLock', value: false });
            } catch (lockError) {
                console.error('Error releasing lock:', lockError);
            }
        }
    };

    
    const postToTwitter = async () => {
        //console.log(await(shareToSocialMedia(accountContext.accountDetails.accountNo, props.image, "twitter")))
        console.log("In Progress");
    };

    const handlePromptClick = async () => {
        const promptDetails = await db.collection.where("uid").equals(props.uid).first();
        console.log("Prompt Details: ", promptDetails);
        
        if (promptDetails) {
            if (props.isMyCollection) {
                props.setUid(props.prompt)
            } else {
                props.setUid(props.uid)
            }
        } else {
            console.log("No record found for uid:", props.uid, props.prompt);
            props.setPrompt(props.hash)
        }

    }

    const handleEscapeKey = (e) => {
        console.log("Key pressed: ", e);
        
        if (e.key === "Escape") {
            setZoomedImage(null)
        }
    }
    useEffect(() => {
        if (zoomedImage) {
            window.addEventListener('keydown', handleEscapeKey);
        }
        // Cleanup the event listener on component unmount
        return () => {
            window.removeEventListener('keydown', handleEscapeKey);
        };
    }, [zoomedImage]);

    return (
        <>
            {failedImage ?
                <div className={`group w-full rounded-xl ${regenLogic ? 'pointer-events-none opacity-90' : null} overflow-hidden relative bg-gray-500 ${imageRegenerating ? 'animate-pulse' : ''}`}>
                    <img className={"w-full opacity-80"} src="https://i.postimg.cc/632gRsSp/Final-logo-Black.png" alt='Help'/>
                    {imageRegenerating ?
                        null
                    :
                        <>
                            <button className={"absolute top-0 right-0 rounded-tr-lg bg-red-600 p-2"} title="Delete Image" onClick={deleteImage}>
                                <img src={cardRemove} alt={"Remove Icon"} />
                            </button>
                            <button className={"absolute top-0 left-0 rounded-tl-lg bg-dark-blue p-2"} title="View Details" onClick={viewDetails}>
                                <img src={cardEye} alt={"View Details Icon"} />
                            </button>
                            <button className={`absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 rounded-lg bg-yellow py-2 px-3 shadow-md font-bold text-m uppercase`} onClick={() => regenerateImage(false)}>Regenerate Image</button>
                            <button className={`absolute top-2/3 left-1/2 transform -translate-x-1/2 -translate-y-1/2 rounded-lg bg-yellow py-2 px-3 shadow-md font-bold text-sm uppercase`} onClick={() => regenerateImage(true)}>Regenerate Workload</button>
                        </>             
                    }
                </div>
            :    
                <>
                    <div className={`group w-full rounded-xl overflow-hidden relative border-4 ${props.online ? model.includes("(AI-Horde)") ? 'border-green-500' : model.includes("(AI-Horde)") ? 'border-green-500' : 'border-white' : 'border-amber-500'}`} onClick={handleDblClick} draggable={"true"} onDragStart={handleDragStart}>
                        <img className={"w-full"} src={`data:image/png;base64,${ props.image }`} alt={`Generated image: ${ props.seed }`} />
                        <div className="hidden group-hover:flex group-hover:bg-black/50 transition w-full h-full absolute top-0 left-0 flex-col justify-between">
                            <div className={`bg-dark-blue/30 backdrop-blur flex w-full flex-row ${showSaveDialog ? 'flex-wrap' : ''} justify-between self-center p-5 rounded gap-4`}>
                                <div className={"flex flex-row gap-2 items-center"}>
                                    {!props.isMyCollection ?
                                        <button className={`${!props.isMyCollection ? "w-7" : null}`}
                                                onClick={toggleCollection}
                                                title={`${props.inCollection ? "Remove from Collection" : "Add to Collection"}`}>
                                            {localInCollection ?
                                                <img src={cardInCollection} alt={"In Collection Icon"}/> :
                                                <img src={cardAdd} alt={"Add to Collection Icon"}/>
                                            }
                                        </button> :
                                        <>
                                            <button className="w-7" onClick={toggleCollection}
                                                    title="Remove from Collection">
                                                <img src={cardInCollection} alt={"In Collection Icon"}/>
                                            </button>

                                            <button
                                                title={`${privateImage ? 'Make the image public' : 'Make the image private'}`}
                                                className="w-7" onClick={handlePrivatePublic}>
                                                {privateImage ?
                                                    <img src={cardPrivate} alt="Private Icon"/>
                                                    :
                                                    <img src={cardPublic} alt="Public Icon"/>
                                                }
                                            </button>
                                        </>
                                    }
                                    <button title="Examine Image" onClick={() => setZoomedImage({image: props.image, seed: props.seed, tag: tag, hash: props.hash, id: props.id})}>
                                        <img src={cardZoom} alt={"Zoom Icon"} />
                                    </button>
                                    <button title="Edit Image" onClick={() => props.setZoomedImage({image: props.image, seed: props.seed})}>
                                        <img src={cardEdit} alt={"Edit Icon"} className="w-7"/>
                                    </button>
                                    <button title="Copy Image" onClick={copyImageToClipboard}>
                                        <img src={cardCopy} alt={"Copy Icon"}/>
                                    </button>
                                    <button title="Save Image" onClick={() => setShowSaveDialog(!showSaveDialog)}>
                                        <img src={cardSave} alt={"Save Icon"}/>
                                    </button>
                                    {props.setUid && props.setImage ?
                                        <button title="Use Image" onClick={() => {
                                            driverContextDispatch({type: 'controlNet'});
                                            collectionContextDispatch({type: 'empty'});
                                            props.setUid(props.uid);
                                            props.setImage(props.image);
                                        }}>
                                            <img src={uploadIconWhite} alt={"Use Image"}/>
                                        </button>
                                        : null}
                                    <button title="Share Image"
                                            onClick={() => setshowShareImageDialog(!showShareImageDialog)}>
                                        <img src={cardShare} alt="Share Icon"/>
                                    </button>
                                    <button title="Tag Image" className="w-7" onClick={handleTagging}>
                                        <img src={cardTag} alt={"Tag Icon"}/>
                                    </button>
                                </div>
                                <div>
                                    <button title="Describe Image" className="w-7" onClick={handleDescribeImage}>
                                        <img src={cardImageDescribe} alt={"Describe Icon"}/>
                                    </button>
                                </div>
                                <div>
                                    <button title="Delete Image" onClick={deleteImage}>
                                        <img src={cardRemove} alt={"Remove Icon"} />
                                    </button>
                                </div>
                                {showSaveDialog ?
                                    <>
                                        <input type={"text"} className={"flex-grow w-full rounded text-dark-blue p-1 text-xs"}
                                            onChange={(e) => setDownloadName(e.target.value)} value={downloadName}
                                            onFocus={(e) => e.target.select()}
                                        />
                                        <div className={"flex-grow w-full flex flex-row justify-center gap-4"}>
                                            <button className={"bg-dark-blue/40 rounded p-2 hover:bg-dark-blue transition"} onClick={() => downloadImage('image/png', 'png')}>.png</button>
                                            <button className={"bg-dark-blue/40 rounded p-2 hover:bg-dark-blue transition"} onClick={() => downloadImage('image/webp', 'webp')}>.webp</button>
                                            <button className={"bg-dark-blue/40 rounded p-2 hover:bg-dark-blue transition"} onClick={downloadPrompt}>.prompt</button>
                                        </div>
                                    </>
                                    : 
                                    null
                                }
                            </div>
                            {showShareImageDialog ?
                                <>
                                    <div className={"flex flex-row justify-center"}>
                                        <button className={"bg-dark-blue/40 rounded p-2 hover:bg-dark-blue transition"} onClick={() => shareImageAction('facebook')}>Facebook</button>
                                        <button className={"bg-dark-blue/40 rounded p-2 hover:bg-dark-blue transition"} onClick={() => shareImageAction('twitter')}>Twitter</button>
                                    </div>
                                </>
                                :
                                null
                            }
                            {Object.keys(promptInfo).length > 0 ?
                                <p className="line-clamp-4 text-center p-5 cursor-pointer hover:text" onClick={() => {handlePromptClick()}}>{promptInfo.prompt}</p>
                                : <div className="text-center p-5">Getting Prompt...</div>}
                            <div className="flex flex-row">
                                <button className={"rounded-bl-lg bg-dark-blue p-2 h-full w-11"} title="View Details" onClick={viewDetails}>
                                    <img src={cardEye} alt={"View Details Icon"} />
                                </button>
                                {props.seed ?
                                    <button className="text-center font-light text-sm p-4 hover:bg-dark-blue/30 hover:backdrop-blur w-full" onClick={() => props.setSeed(props.seed)}>#{props.seed}</button> : <div className={"h-12"}></div>}
                            </div>    
                        </div>
                        {props.isMyCollection ?
                            <div className={`absolute group-hover:hidden top-0 left-0 rounded px-3 py-2 bg-dark-blue text-base`}>{visibility}</div>
                        :
                            null    
                        }
                        <div className={`absolute group-hover:hidden top-0 right-0 rounded px-3 py-2 bg-dark-blue/60 text-base`}>{props.model}</div>
                        {tag ? 
                            <div className={`absolute group-hover:hidden bottom-0 left-0 rounded px-3 py-2 bg-dark-blue/40 text-sm`}>{tag}</div>
                        :
                            null
                        }
                        <div className={`absolute group-hover:hidden bottom-0 right-0 rounded px-3 py-2 bg-dark-blue/40 text-sm`}>{dimensions}</div>
                        <Modal open={open} onClose={() => setOpen(false)} center>
                                <h2 className="text-2xl mb-5 font-bold">Category</h2>
                                <p>
                                    Edit the tags you would like to add with the image
                                </p>
                                <div className="flex flex-row items-center justify-between my-5">
                                    <p className="place-content-start">Original Tag: <span className="font-bold">{tag}</span></p>
                                    <div id="clearTags" className={"flex flex-row items-center place-content-end"}>
                                        <ToggleInput id={"clearTags"} onChange={() => handleClearTag()}/>
                                        <label htmlFor={"clearTags"}
                                                className={`inline-block ml-2 text-sm font-medium ${clearTags ? 'text-yellow' : 'text-dark-blue'} transition`}>Clear Tags?</label>
                                    </div>
                                </div>
                                <div className={"p-5 my-5 border border-dark-blue rounded-lg"}>
                                    <label className="block mb-2 text-sm font-medium" htmlFor="existing">Existing Category</label>
                                    {/* <select name="existing" className={"rounded-lg text-dark-blue border border-dark-blue p-2 w-2/5"} value={tag} onChange={(e) => setTag(e.target.value)}>
                                        <option value={`${props.tag}`}>{props.tag}</option>
                                    </select> */}
                                    <Select options={options} components={animatedComponents} onChange={(e) => setSelectedOptions(e)} isMulti isClearable onKeyDown={(e) => handleEnter(e)}/>
                                </div>
                                <div className="flex flex-row items-center">
                                    <hr className={"flex-grow border border-dark-blue/40 bg-dark-blue/40"} />
                                    <h1 className="mx-4 font-bold text-xl">OR</h1>
                                    <hr className={"flex-grow border border-dark-blue/40 bg-dark-blue/40"} />
                                </div>
                                    <p>
                                        Type in a new category to have more ease in sorting your images
                                    </p>
                                    <div className={"p-5 my-5 border border-dark-blue rounded-lg"}>
                                        <label className="block mb-2 text-sm font-medium" htmlFor="emailAddress">New Category</label>
                                        <input type="text" name="emailAddress" className="w-full rounded-lg text-dark-blue border border-dark-blue p-2" placeholder="Category"
                                        value={inputTag} onChange={(e) => setInputTag(e.target.value)} onKeyDown={(e) => handleEnter(e)}/>
                                    </div>
                                <div className="flex flex-row justify-center gap-4">
                                    <button onClick={() => editTagOnImage()} className="rounded w-1/2 mx-auto mt-6 mb-3 p-2 bg-yellow text-dark-blue shadow font-bold">
                                        {tagLoading ?
                                                <svg aria-hidden="true" role="status" class="inline w-5 h-5 mr-3 mb-1 text-dark-blue animate-spin" viewBox="0 0 99 101" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                            <path d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z" fill="#ffb02e"/>
                                                            <path d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z" fill="currentColor"/>
                                                </svg>
                                            :
                                                null
                                        }
                                        Categorize
                                    </button>
                                    <button onClick={() => setOpen(false)} className="rounded w-1/2 mx-auto mt-6 mb-3 p-2 bg-dark-blue text-yellow shadow font-bold">Cancel</button>
                                </div>
                            </Modal>
                        <Modal open={openDescribeImage} onClose={() => setOpenDescribeImage(false)} center>
                            <h2 className="text-2xl mb-5 font-bold">Image Description</h2>
                            <p style={{minWidth: '600px'}}>
                                {imageDescriptionLoading ? 
                                    <svg aria-hidden="true" role="status" class="inline w-5 h-5 mr-3 mb-1 text-dark-blue animate-spin" viewBox="0 0 99 101" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z" fill="#ffffff"/>
                                    <path d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z" fill="currentColor"/>
                                </svg> 
                                : 
                                    null
                                }
                                {/*
                                <div className="dot-container">
                                    <span className="text">Generating</span>
                                    <span className="dot"></span>
                                    <span className="dot"></span>
                                    <span className="dot"></span>
                                </div>
                                */}
                                {imageDescription}
                            </p>
                            <br></br>
                            <div>
                                <button className="me-3" title="Copy Description To Clipboard"
                                        onClick={() => copyDescriptionToClipboard(imageDescription, setClipboardMessage)}>
                                <img src={cardCopyDescription} alt={"Copy Description To Clipboard Icon"}/>
                                </button>
                                <button className="me-3" title="Save As Prompt"
                                        onClick={() => downloadDescriptionAsPromptFile(imageDescription, downloadName)}>
                                    <img src={cardSaveDescription} alt={"Save As Prompt Icon"}/>
                                </button>
                                <button className="me-3" title="Populate Prompt" onClick={() => populatePromptField(imageDescription, updatePrompt)}>
                                    <img src={cardPopulatePrompt} alt={"Populate Prompt Icon"}/>
                                </button>
                                <span>{clipboardMessage}</span>
                            </div>
                        </Modal>
                        <Modal open={openShare} onClose={() => setShare(false)} center>
                            <h2 className="text-2xl mb-5 font-bold">Share this Image</h2>
                            <div className="modal-body">
                                <p>Choose a platform to share this image:</p>
                                <div className="mt-10 text-center">
                                    <a onClick={postToTwitter}>Post to Twitter</a>

                                </div>
                            </div>
                        </Modal>
                    </div>
                    {zoomedImage ?
                        <div className={"fixed top-0 left-0 z-10 flex flex-col justify-center place-items-center h-full w-screen bg-dark-blue/40 backdrop-blur"}>
                            <div className={"w-full flex flex-row justify-end items-center justify-self-start"} onKeyDown={(e) => handleEscapeKey(e)}>
                                    <button className={"px-5 py-2 text-white m-2 hover:text-yellow transition"} onClick={() => setZoomedImage(null)}>
                                        <img src={CloseIcon} alt='Close Full Image Viewer' className='h-7'/>
                                    </button>
                            </div>
                            <FullImageViewer image={zoomedImage.image} seed={zoomedImage.seed} tag={zoomedImage.tag} id={zoomedImage.id} setTag={(newTag) => setTag(newTag)}/>
                        </div>
                        :
                            null    
                        }
                </>
            }
        </>
    );
});

export default CollectionImage;
